import quickFetch from 'quick-fetch'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../u... Remove this comment to see the full error message

import memoize from '../utilities/memoize';
import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
const portalId = PortalIdParser.get();
const url = `hubs-settings/v1/hubs/${portalId}/settings`;
const earlyRequestName = 'settings';
export const setSetting = (key, value) => http.post(url, {
  data: {
    hubId: portalId,
    internal: false,
    key,
    value
  }
});
export const fetchSettings = memoize(() => {
  const earlyRequest = quickFetch.getRequestStateByName(earlyRequestName);

  if (!earlyRequest) {
    return http.get(url);
  }

  return new Promise(resolve => {
    earlyRequest.whenFinished(result => {
      resolve(result);
      quickFetch.removeEarlyRequest(earlyRequestName);
    });
    earlyRequest.onError(() => {
      quickFetch.removeEarlyRequest(earlyRequestName);
      return http.get(url).then(resolve).catch(() => {});
    });
  });
});